import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Typography from '@mui/material/Typography';
import SendVerificationEmail from './messages/SendVerificationEmail';
import { signOut } from 'firebase/auth';
import { auth } from '../../contexts/authentication';
import { useNewEmail } from '../globalStates/NewEmail';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

interface Props {
  content?: string | null,
  navigateTo?: string | null,
  setShowAlertWithDone: React.Dispatch<React.SetStateAction<boolean>>,
  alertMessage?: string | null,
}

export default function AlertWithDone({ content, navigateTo, setShowAlertWithDone, alertMessage }: Props) {
  const [open, setOpen] = React.useState(true);
  const { setNewEmail } = useNewEmail();
  const navigate = useNavigate();

  const handleClose = () => {
    setNewEmail('');
    setOpen(false);
    setShowAlertWithDone(false);
    if (navigateTo) {
      navigate(navigateTo);
    }
  }

  return (
    <React.Fragment>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          Atenção!
        </DialogTitle>
        <DialogContent dividers>
          <Typography gutterBottom>
            {content === 'sendVerificationEmail' ? (
              <SendVerificationEmail />
            ) : (
              alertMessage
            )
            }
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>
            Entendido
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </React.Fragment>
  );
}
